import type { TableTheme } from '../themes/theme';

export const themes: { [key: string]: TableTheme } = {};
